import React from "react";
import { Route, RouteComponentProps, RouteProps } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import { ThemeProvider } from "styled-components";
import { theme } from "../lib/theme";
import { signIn } from "../lib/signInNavigation";
import LoadingIndicator from "./shared/LoadingIndicator";

interface PrivateRouteParams extends RouteProps {
  component:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>;
}

export function PrivateRoute({
  component: Component,
  ...rest
}: PrivateRouteParams) {
  const { keycloak, initialized } = useKeycloak();
  if (!initialized) {
    return (
      <ThemeProvider theme={theme}>
        <LoadingIndicator fullHeight />
      </ThemeProvider>
    );
  }
  if (!keycloak?.authenticated) {
    signIn(keycloak);
    return (
      <ThemeProvider theme={theme}>
        <LoadingIndicator fullHeight />
      </ThemeProvider>
    );
  }
  return <Route {...rest} render={(props) => <Component {...props} />} />;
}
